import React from "react";
import PhoneMockup from "../components/phoneMockup";

const AppLaunchTeaser = () => {
  return (
    <section className="bg-cloud py-16 lg:py-24">
      <div className="max-w-content mx-auto grid grid-cols-1 items-center gap-12 px-6 lg:grid-cols-2 lg:gap-16 lg:px-10">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center rounded-full bg-gold-soft px-3 py-1 text-xs font-semibold text-gold">
            Coming soon
          </span>
          <h2 className="mt-4 text-3xl font-bold text-brand sm:text-4xl">
            The Nirkana app launches October 18
          </h2>
          <p className="mt-4 max-w-prose text-muted">
            We're building a dedicated app for planning your event on the
            go — browsing packages, tracking your order, and chatting with
            your coordinator, all in one place. It's currently in
            development alongside our birthday launch on the website.
          </p>
          <p className="mt-4 max-w-prose text-sm text-muted">
            Until then, everything on the app will also be available right
            here on the website.
          </p>
        </div>

        <div className="order-1 lg:order-2">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
};

export default AppLaunchTeaser;
